module.exports = __webpack_public_path__ + "img/196.597411ae.jpg";